type SessionStorageKeyItem = {
  key: string;
  item: string;
};

export const findSessionStorageByValue = (string: string): SessionStorageKeyItem | null => {
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    try {
      const item = JSON.parse(sessionStorage.getItem(key));

      // Check if the value property contains the specified domain
      if (item?.value?.includes(string)) {
        return {
          key: key,
          item: item,
        };
      }
    } catch {
      continue;
    }
  }
  return null;
};
